var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.845 7.5H23.04C24.06 7.5 24.885 8.34 24.885 9.375V11.43C24.885 12.18 24.42 13.11 23.955 13.575L19.98 17.13C19.425 17.595 19.05 18.54 19.05 19.275V23.295C19.05 23.85 18.675 24.6 18.225 24.885L16.935 25.725C15.735 26.475 14.07 25.635 14.07 24.135V19.17C14.07 18.51 13.695 17.67 13.335 17.205L9.82498 13.455C9.35998 12.99 9 12.15 9 11.58V9.43501C9 8.34001 9.82497 7.5 10.845 7.5Z",
    fill: "#111827"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 9H27.9C27.48 9 27.15 9.33 27.15 9.75C27.15 10.47 27.15 11.43 27.15 11.43C27.15 12.915 26.355 14.37 25.575 15.165L21.495 18.81C21.45 18.915 21.375 19.065 21.33 19.185V23.31C21.33 24.675 20.52 26.16 19.41 26.835L18.18 27.63C17.49 28.065 16.725 28.275 15.96 28.275C15.27 28.275 14.58 28.095 13.95 27.75C12.975 27.21 12.3 26.325 12 25.305V21.315C12 21.12 11.925 20.925 11.775 20.79L10.275 19.29C9.79496 18.825 9 19.155 9 19.815V31.5C9 35.64 12.36 39 16.5 39H31.5C35.64 39 39 35.64 39 31.5V16.5C39 12.36 35.64 9 31.5 9Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 26.625H25.5C24.885 26.625 24.375 26.115 24.375 25.5C24.375 24.885 24.885 24.375 25.5 24.375H33C33.615 24.375 34.125 24.885 34.125 25.5C34.125 26.115 33.615 26.625 33 26.625Z",
    fill: "#111827"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33 32.625H22.5C21.885 32.625 21.375 32.115 21.375 31.5C21.375 30.885 21.885 30.375 22.5 30.375H33C33.615 30.375 34.125 30.885 34.125 31.5C34.125 32.115 33.615 32.625 33 32.625Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentFilter);
export default __webpack_public_path__ + "static/media/documentFilter.8bdd23a118f8261f06a20f035c20213b.svg";
export { ForwardRef as ReactComponent };